import type { SalarySystemType } from '../enums/SalarySystemType'

export class SystemSalaryFilterEntity {
  name?: string
  type?: SalarySystemType
  page?: number
  limit?: number
  sortField?: string
  sortDescending?: boolean
}
